<c-card class="mb-4 shadow-lg">
  <c-card-body>
    <c-col xs="12">
      <button cButton color="primary" variant="outline" (click)="toggleModal()">
        Add New License
      </button>

      <c-smart-table
        [activePage]="1"
        [columnSorter]="true"
        [columns]="LicensesColumns"
        [itemsPerPageSelect]="true"
        tableFilterPlaceholder="Type Here"
        [itemsPerPage]="10"
        [items]="LicensesDataToShow"
        [sorterValue]="{ column: 'name', state: 'asc' }"
        [tableFilter]="false"
        tableFilterLabel="  Search:"
        [tableProps]="{ hover: true, responsive: true }"
        [tableBodyProps]="{ align: 'middle' }"
        clickableRows
        header
        pagination
        [loading]="Loading"
        (rowClick)="ShowLicenseDetails($event.item)"
      >
        <ng-template cTemplateId="tableDetails" let-item="item">
          <div [visible]="this.details_visible[item._id] === true" cCollapse>
            <c-card class="rounded-0">
              <c-card-footer>
                <div>
                  <button
                    cButton
                    class="ms-1 mt-1"
                    color="primary"
                    variant="outline"
                    style="padding: 5px 10px; margin-left: 100px"
                    size="sm"
                    (click)="EditModule(item)"
                  >
                    Edit
                  </button>
                  <button
                    cButton
                    class="ms-1 mt-1"
                    color="danger"
                    variant="outline"
                    style="padding: 5px 10px; margin-left: 100px"
                    size="sm"
                    (click)="DeleteModule(item)"
                  >
                    Delete
                  </button>
                </div>
              </c-card-footer>
            </c-card>
          </div>
        </ng-template>
        <ng-template
          cTemplateId="tableData"
          let-columnName="columnName"
          let-item="item"
          let-tdContent="tdContent"
        >
          <td>
            <ng-container [ngSwitch]="columnName">
              <!-- <ng-container *ngSwitchCase="'status'">
                                    <c-badge [color]="getBadge(tdContent)">
                                            {{(item[columnName])}}
                                    </c-badge>
                                </ng-container> -->
              <ng-container *ngSwitchCase="'Actions'" class="py-2">
                <button
                  (click)="toggleDetails(item._id)"
                  cButton
                  color="primary"
                  size="sm"
                  variant="outline"
                >
                  Actions
                </button>
              </ng-container>

              <ng-container *ngSwitchCase="'dateUpdatedUTC'" class="py-2">
                {{ tdContent | date : "MM/dd/yyyy" }}
              </ng-container>
              <ng-container *ngSwitchCase="'date_Start'" class="py-2">
                {{ tdContent | date : "MM/dd/yyyy" }}
              </ng-container>
              <ng-container *ngSwitchCase="'date_Expire'" class="py-2">
                {{ "Unlimited" }}
              </ng-container>
              <ng-container *ngSwitchCase="'date_TrialEnd'" class="py-2">
                {{ tdContent | date : "MM/dd/yyyy" }}
              </ng-container>
              <ng-container *ngSwitchCase="'isActive'" class="py-2">
                {{ tdContent ? "Active" : "Inactive" }}
              </ng-container>
              <ng-container *ngSwitchCase="'picture'" class="py-2">
                <div class="text-center" *ngIf="tdContent">
                  <c-avatar
                    [src]="BaseService.USERIMAGESURL + tdContent"
                  ></c-avatar>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ tdContent }}
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </c-smart-table>
    </c-col>
  </c-card-body>

  <!-- <c-card-body>
    <c-row>
      <c-col sm="12">
        <h4 class="card-title mb-0" id="traffic">Create NFR License</h4>
        <hr />

        <div class="container">
          <c-row>
            <c-col sm="3">
              <label for="selectUser">Select Client *</label>
              <div class="form-group mt-2">
                <select id="selectUser" class="form-control" disabled>
                  <option selected [value]="UserData?.id">
                    {{ UserData?.userDisplayName }}
                  </option>
                </select>
              </div>
            </c-col>
            <c-col sm="3">
              <label for="selectproduct">Select Product *</label>
              <div class="form-group mt-2">
                <select
                  id="selectproduct"
                  class="form-control"
                  (change)="GetFeatureList($event.target.value)"
                >
                  <option>Select Product</option>
                  <option
                    *ngFor="let prodata of ProductsData"
                    [value]="prodata.id"
                  >
                    {{ prodata.productName }}
                  </option>
                </select>
              </div>
            </c-col>
            <c-col sm="3" *ngIf="IsProductSelected">
              <label for="selectDuration">Select Duration *</label>
              <div class="form-group mt-2">
                <select
                  id="selectDuration "
                  #duration
                  class="form-control"
                  (ngModelChange)="calculateTotalPrice()"
                  (change)="durationcheck($event.target.value)"
                >
                  <option value="0">Select Duration</option>
                  <ng-container *ngFor="let prodata of DurationOption">
                    <option *ngIf="prodata.isActive" [value]="prodata.id">
                      {{ prodata.optionTitle }}
                      <span *ngIf="prodata.isTrial">(Trial)</span>
                    </option>
                  </ng-container>
                </select>
              </div>
            </c-col>
            <c-col sm="3" *ngIf="IsAllowedCentral">
              <input
                type="checkbox"
                [(ngModel)]="isextraStore"
                (change)="enablees()"
              />
              RMH Central
              <label for="extraNOS"> (Multi Store) *</label>
              <div class="form-group mt-2">
                <input
                  type="number"
                  id="extraNOS"
                  placeholder="Additional Stores"
                  [(ngModel)]="extraNOS"
                  name="fullName"
                  min="1"
                  (ngModelChange)="calculateTotalPrice()"
                  class="form-control mt-1 mb-1"
                  [attr.disabled]="!isextraStore ? true : null"
                  required
                />
              </div>
            </c-col>
            <c-col sm="12">
              
              <div
                class="mt-2"
                *ngIf="durationoptionselected && taskList != ''"
              >
                <table cTable cTableColor="info">
                  <thead cTableColor="dark">
                    <tr>
                      <td><b> Modules and Features List </b></td>
                      <td align="right" style="width: 130px">
                        <b> Monthly </b>
                      </td>
                      <td
                        *ngIf="IsAllowedCentral"
                        align="right"
                        style="width: 150px"
                      >
                        <b> Additional Store </b>
                      </td>
                      <td align="right" style="width: 130px">
                        <b> One Time </b>
                      </td>
                      <td align="right" style="width: 130px"><b> Total </b></td>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let module of taskList">
                      <tr>
                        <th>
                          {{ module.moduleName }}
                        </th>
                        <td></td>
                        <td></td>

                        <td *ngIf="IsAllowedCentral"></td>
                        <td></td>
                      </tr>
                      <ng-container *ngFor="let feature of module.featureList">
                        <tr>
                          <td style="padding-left: 60px">
                            <input
                              type="checkbox"
                              [(ngModel)]="feature.selected"
                              (change)="handleCheckboxChange(feature)"
                            />
                            {{ feature.featureName }}
                          </td>
                          <td align="right">
                            {{ feature.price | currency }}
                          </td>
                          <td align="right" *ngIf="IsAllowedCentral">
                            {{ feature.price_ExtraStore | currency }}
                          </td>
                          <td align="right">
                            {{ feature.price_OneTime | currency }}
                          </td>
                          <td>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>

                    <tr style="border-top: 3px solid black">
                      <td><h6>Total Billable To Client</h6></td>
                      <td align="right">
                        <h6>{{ this.totaloffeatureprice | currency }}</h6>
                      </td>

                      <td align="right" *ngIf="IsAllowedCentral">
                        <h6>{{ storewithduration | currency }}</h6>
                      </td>
                      <td align="right">
                        <h6>{{ totalofonetimeprice | currency }}</h6>
                      </td>

                      <td align="right">
                        <h6>{{ totalPrice + storewithduration | currency }}</h6>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <h6>Partner Margin ({{ partnerpercentage }}%)</h6>
                      </td>
                      <td align="right">
                        <h6>
                          {{
                            this.totaloffeatureprice * (partnerpercentage / 100)
                              | currency
                          }}
                        </h6>
                      </td>

                      <td align="right" *ngIf="IsAllowedCentral">
                        <h6>
                          {{
                            storewithduration * (partnerpercentage / 100)
                              | currency
                          }}
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            totalofonetimeprice * (partnerpercentage / 100)
                              | currency
                          }}
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            (totalPrice + storewithduration) *
                              (partnerpercentage / 100) | currency
                          }}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td><h6>Net Payable By Partner</h6></td>

                      <td align="right">
                        <h6>
                          {{
                            this.totaloffeatureprice -
                              this.totaloffeatureprice *
                                (partnerpercentage / 100) | currency
                          }}
                        </h6>
                      </td>
                      <td align="right" *ngIf="IsAllowedCentral">
                        <h6>
                          {{
                            storewithduration -
                              storewithduration * (partnerpercentage / 100)
                              | currency
                          }}
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            totalofonetimeprice -
                              totalofonetimeprice * (partnerpercentage / 100)
                              | currency
                          }}
                        </h6>
                      </td>
                      <td align="right">
                        <h6>
                          {{
                            totalPrice +
                              storewithduration -
                              (totalPrice + storewithduration) *
                                (partnerpercentage / 100) | currency
                          }}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <button (click)="updateAllTasks()" class="btn btn-primary">
                  Create License
                </button>
              </div>
            </c-col>
          </c-row>
        </div>
      </c-col>
    </c-row>
  </c-card-body> -->
</c-card>

<c-modal
  #LicenseModal
  alignment="center"
  id="LicenseModal"
  size="xl"
  backdrop="static"
  [visible]="ModalVisibleLicenseDetails"
>
  <c-modal-header>
    <h5 cModalTitle>License Detail</h5>
    <button (click)="toggleModalLicenseDetails()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <c-row *ngIf="licenseData != null">
      <div class="container">
        <h6>Client Name : {{ UserData.userDisplayName }}</h6>
        <h6>License Key : {{ licenseData?.license_Code }}</h6>

        <table cTable cTableColor="info">
          <thead cTableColor="dark">
            <tr>
              <th scope="col">Product Name & Features List</th>
              <th scope="col">Purchase Date</th>
              <th scope="col">Expired On</th>
              <th scope="col">Extra Stores</th>
              <th scope="col">Trial</th>
              <th scope="col">Active</th>
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr>
                <th>
                  {{ licenseData?.productName }}
                </th>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <ng-container
                *ngFor="let feature of licenseData?.license_Features"
              >
                <tr>
                  <td style="padding-left: 60px">
                    {{ feature.featureName }}
                  </td>
                  <td>
                    {{ feature.date_Start | date : "MM/dd/yyyy" }}
                  </td>
                  <td>
                    {{ feature.date_End | date : "MM/dd/yyyy" }}
                  </td>
                  <td>
                    {{ licenseData.extraStores }}
                  </td>
                  <td>
                    {{ feature.isTrial ? "Yes" : "No" }}
                  </td>
                  <td>
                    {{ feature.isActive ? "Yes" : "No" }}
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </c-row>
    <!-- <button class="btn btn-primary mt-2 mb-1" [cModalToggle]="LicenseModal.id">
        Submit
      </button> -->
  </c-modal-body>
</c-modal>

<!-- NFRLicenseCreate -->
<c-modal
  #NFRLicenseCreate
  alignment="center"
  id="NFRLicenseCreate"
  backdrop="static"
  [visible]="ModalVisible"
  size="xl"
>
  <c-modal-header>
    <h5 cModalTitle>Create NFR License</h5>
    <button (click)="toggleModal()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <c-col sm="12">
      <!-- <h4 class="card-title mb-0" id="traffic">Create License</h4> -->
      <!-- <hr /> -->

      <div class="container">
        <c-row>
          <c-col sm="3">
            <label for="selectUser">User *</label>
            <div class="form-group mt-2">
              <select id="selectUser" class="form-control" disabled>
                <option selected [value]="UserData?.id">
                  {{ UserData?.userDisplayName }}
                </option>
              </select>
            </div>
          </c-col>
          <c-col sm="3">
            <label for="selectproduct">Select Product *</label>
            <div class="form-group mt-2">
              <select
                id="selectproduct"
                class="form-control"
                (change)="GetFeatureList($event.target.value)"
              >
                <option>Select Product</option>
                <option
                  *ngFor="let prodata of ProductsData"
                  [value]="prodata.id"
                >
                  {{ prodata.productName }}
                </option>
              </select>
            </div>
          </c-col>
          <c-col sm="3" *ngIf="IsProductSelected">
            <label for="selectDuration">Select Duration *</label>
            <div class="form-group mt-2">
              <select
                id="selectDuration "
                #duration
                class="form-control"
                (ngModelChange)="calculateTotalPrice()"
                (change)="durationcheck($event.target.value)"
              >
                <option value="0">Select Duration</option>

                <ng-container
                  *ngFor="let prodata of DurationOption; let i = index"
                >
                  <option
                    *ngIf="prodata.isActive && i === 0"
                    [value]="prodata.id"
                  >
                    {{ "Unlimited" }}
                    <!-- <span *ngIf="prodata.isTrial ">(Trial)</span> -->
                  </option>
                </ng-container>
              </select>
            </div>
          </c-col>
          <c-col sm="3" *ngIf="IsAllowedCentral">
            <input
              type="checkbox"
              [(ngModel)]="isextraStore"
              (change)="enablees()"
            />
            RMH Central
            <label for="extraNOS"> (Multi Store) *</label>
            <div class="form-group mt-2">
              <input
                type="number"
                id="extraNOS"
                placeholder="Additional Stores"
                [(ngModel)]="extraNOS"
                name="fullName"
                min="1"
                (ngModelChange)="calculateTotalPrice()"
                class="form-control mt-1 mb-1"
                [disabled]="!isextraStore ? true : null"
                required
              />
            </div>
          </c-col>
          <c-col sm="12">
            <!-- <div *ngIf="msg">
                <div [innerHTML]="msg"></div>
              </div> -->
            <div class="mt-2" *ngIf="durationoptionselected && taskList != ''">
              <table cTable cTableColor="info">
                <thead cTableColor="dark">
                  <tr>
                    <td><b> Modules and Features List </b></td>
                    <td align="right" style="width: 130px">
                      <!-- <b> Monthly </b> -->
                    </td>
                    <td
                      *ngIf="IsAllowedCentral"
                      align="right"
                      style="width: 150px"
                    >
                      <!-- <b> Additional Store </b> -->
                    </td>
                    <td align="right" style="width: 130px">
                      <!-- <b> One Time </b> -->
                    </td>
                    <td align="right" style="width: 130px">
                      <!-- <b> Total </b> -->
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let module of taskList">
                    <tr>
                      <th>
                        {{ module.moduleName }}
                      </th>
                      <td></td>
                      <td></td>

                      <td *ngIf="IsAllowedCentral"></td>
                      <td></td>
                    </tr>
                    <ng-container *ngFor="let feature of module.featureList">
                      <tr>
                        <td style="padding-left: 60px">
                          <input
                            type="checkbox"
                            [(ngModel)]="feature.selected"
                            (change)="handleCheckboxChange(feature)"
                          />
                          {{ feature.featureName }}
                        </td>
                        <td align="right">
                          <!-- {{ feature.price | currency }} -->
                        </td>
                        <td align="right" *ngIf="IsAllowedCentral">
                          <!-- {{ feature.price_ExtraStore | currency }} -->
                        </td>
                        <td align="right">
                          <!-- {{ feature.price_OneTime | currency }} -->
                        </td>
                        <td>
                          <!-- {{featureTotalPrice | currency}} -->
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>

                  <!-- <tr style="border-top: 3px solid black">
                    <td><h6>Total Billable To Client</h6></td>
                    <td align="right"> 
                      <h6>{{this.totaloffeatureprice | currency }}</h6></td>

                      <td align="right" *ngIf="IsAllowedCentral">
                        <h6>{{storewithduration | currency}}</h6>
                      </td>
                      <td align="right"> 
                      <h6>{{totalofonetimeprice | currency}}</h6></td>
                    
                    <td align="right">
                      <h6>{{ totalPrice + storewithduration | currency }}</h6>
                    </td>
                  </tr>
                  
                 
                  <tr>
                    <td><h6>Partner Margin ({{ partnerpercentage }}%)</h6></td>
                    <td align="right"> 
                      <h6>{{this.totaloffeatureprice * (partnerpercentage / 100) | currency }}</h6></td>

                      <td align="right" *ngIf="IsAllowedCentral">
                        <h6>{{storewithduration  * (partnerpercentage / 100) | currency}}</h6>
                      </td>

                      <td align="right"> 
                      <h6>{{totalofonetimeprice * (partnerpercentage / 100) | currency}}</h6></td>

                    <td align="right">
                      <h6>{{ (totalPrice + storewithduration) * (partnerpercentage / 100)  | currency }}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td><h6>Net Payable By Partner</h6></td>

                    <td align="right">
                      <h6> {{this.totaloffeatureprice - (this.totaloffeatureprice * (partnerpercentage / 100)) | currency }}</h6>
                    </td>
                    <td align="right" *ngIf="IsAllowedCentral">
                      <h6>{{storewithduration  - (storewithduration * (partnerpercentage / 100)) | currency}}</h6>
                    </td>
                   
                    <td align="right">
                      <h6>{{totalofonetimeprice - ( totalofonetimeprice* (partnerpercentage / 100)) | currency}}</h6>
                       </td>
                    <td align="right">
                      <h6>{{ (totalPrice + storewithduration) -  ((totalPrice + storewithduration) * (partnerpercentage / 100)) | currency }}</h6>
                    </td>
                  </tr> -->
                </tbody>
              </table>
              <button
                    type="submit"
                    class="btn btn-primary px-4 mb-3 mt-2"
                    style="margin: auto"
                    [disabled]="ButtonLoading"
                    (click)="updateAllTasks()"
                  >
                    <c-spinner
                      aria-hidden="true"
                      size="sm"
                      *ngIf="ButtonLoading"
                    ></c-spinner>
                    Add License
                  </button>

              <!-- <button (click)="updateAllTasks()" class="btn btn-primary">
                Add License
              </button> -->
            </div>
          </c-col>
        </c-row>
      </div>
    </c-col>
  </c-modal-body>
</c-modal>
